<template>
    <div>
        <v-snackbar v-model="snackbar" :top="true" :color="color" :timeout="6000">
            <span v-if="snackbar_msg != null">{{ snackbar_msg }}</span>
            <v-btn dark text @click="snackbar = false">Close</v-btn>
        </v-snackbar>
        <v-card :loading="tt_load" class="box">
            <v-toolbar class="toolbar" flat dense>
                <v-toolbar-title>
                    Time Table
                </v-toolbar-title>
                <v-divider class="mx-4" color="white" inset vertical></v-divider>
                <v-spacer></v-spacer>
                <v-btn rounded color="success" small @click="fnExcelReport('my-table-id', 'FacultyTT')"><v-icon
                        class="mr-1" small color="white">mdi-export</v-icon>Export</v-btn>
                <v-checkbox v-model="showRoom" color="white" text-color="white" class="checkbox-label"></v-checkbox>Show
                Room
            </v-toolbar>
            <v-card v-if="final_tt_list != null" flat>
                <div id="my-table-id">
                    <center class="mt-2">
                        <h4>
                            <span v-if="org_basic_data.trust_name">{{ org_basic_data.trust_name }}</span>
                        </h4>
                        <span v-if="org_basic_data.school_name">{{ org_basic_data.school_name
                            }}</span><br />
                        <span>{{ org_basic_data.address }}</span>
                    </center>
                    <hr class="mt-2">
                    <v-col cols="12" sm="12" md="12" class="pa-1" v-for="(ftt, index) in final_tt_list" :key="index">
                        <v-row justify="center" dense> <strong> Stream :: </strong> {{ ftt.stream }} </v-row>
                        <center>
                            <p v-if="selectedFacultyName"><b> Faculty :: </b>{{ selectedFacultyName }}</p>
                        </center>
                        <v-simple-table class="elevation-1 mytable" dense>
                            <thead>
                                <tr>
                                    <th></th>
                                    <th class="toolbar" v-for="(s, index) in day_list" :key="index">
                                        {{ s }}
                                    </th>
                                </tr>
                            </thead>
                            <tbody>
                                <tr v-for="(tt, index) in ftt.tt_list" :key="index">
                                    <td>
                                        {{ index }}
                                    </td>
                                    <td v-for="(data, index) in tt" :key="index">
                                        <v-btn v-if="data.toshowcompulsory == 0" width="100%" small text
                                            :title="`Subject:${data.tt_course_tip} Std:${data.tt_std} Div:${data.tt_div} Room:${data.tt_room} Event:${data.tt_event_tip}`">
                                            <span v-if="data.tt_course != null">
                                                <v-icon small color="green">mdi-book-open-page-variant</v-icon>
                                                {{ data.tt_course }}
                                            </span>
                                            <span v-if="showRoom && data.tt_room != null">
                                                <v-icon color="blue" small>mdi-warehouse</v-icon>
                                                {{ data.tt_room }}
                                            </span>
                                            <span v-if="data.tt_event != null">
                                                <v-icon color="green" small>mdi-cricket</v-icon>
                                                {{ data.tt_event }}
                                            </span>
                                            <span v-if="data.tt_div != null">
                                                <v-icon color="#9808EB" small>mdi-standard-definition</v-icon>
                                                {{ data.tt_std }}-{{ data.tt_div }}
                                            </span>
                                            <span v-if="data.tt_mul_inst != ''">
                                                <v-icon color="#9808EB" small>mdi-account-plus</v-icon>
                                                <span v-for="i, index in data.tt_mul_inst" :key="index"> {{ index + 1
                                                }}.{{ i
                                                    }}</span>
                                            </span>
                                            <span v-if="data.tt_web_link != null && data.tt_web_link != '--'">
                                                <a :href="data.tt_web_link" v-if="data.tt_web_link" target="_blank">
                                                    <v-tooltip top>
                                                        <template v-slot:activator="{ on, attrs }">
                                                            <v-icon color="white" v-bind="attrs" v-on="on" size="25">mdi
                                                                mdi-link</v-icon>
                                                        </template>
                                                        <span> Webinar Link!!! </span>
                                                    </v-tooltip>
                                                </a>
                                            </span>
                                        </v-btn>
                                        <span v-if="data.toshowcompulsory == 1">
                                            <span v-if="data.electives.length != 0">
                                                <v-tooltip right color="#00DBDE" dark>
                                                    <template v-slot:activator="{ on, attrs }">
                                                        <v-btn v-bind="attrs" v-on="on" width="100%" :id="data.tt_id"
                                                            v-for="(ele, index) in data.electives" :key="index" small
                                                            text class="pt-2 mt-2 btn1-grad"
                                                            :title="`Subject:${ele.ele_crs} Std:${ele.ele_std} Div:${ele.ele_div} Room:${ele.ele_room} Event:${ele.ele_event} Instructor:${ele.ele_instructor}`">
                                                            <span v-if="ele.ele_crs != null">
                                                                <v-icon small
                                                                    color="green">mdi-book-open-page-variant</v-icon>
                                                                {{ ele.ele_crs }}
                                                            </span>
                                                            <a :href="ele.ele_link" v-if="ele.ele_link" target="_blank">
                                                                <v-tooltip top>
                                                                    <template v-slot:activator="{ on, attrs }">
                                                                        <v-icon color="white" v-bind="attrs" v-on="on"
                                                                            size="20">mdi mdi-link</v-icon>
                                                                    </template>
                                                                    <span> Webinar Link!!! </span>
                                                                </v-tooltip>
                                                            </a>
                                                            <span v-if="showRoom && ele.ele_room != null">
                                                                <v-icon color="blue" small>mdi-warehouse</v-icon>
                                                                {{ ele.ele_room }}
                                                            </span>
                                                            <span v-if="ele.ele_event != null">
                                                                <v-icon color="green" small>mdi-cricket</v-icon>
                                                                {{ ele.ele_event }}
                                                            </span>
                                                            <span v-if="ele.ele_instructor != '--'">
                                                                <v-icon color="#9808EB" small>mdi-account-tie</v-icon>
                                                                {{ ele.ele_instructor }}
                                                            </span>
                                                            <span v-if="ele.tt_ele_mul_inst != ''">
                                                                <v-icon color="#9808EB" small>mdi-account-plus</v-icon>
                                                                <span v-for="i, index in ele.tt_ele_mul_inst"
                                                                    :key="index"> {{ index + 1 }}.{{ i }}</span>
                                                            </span>
                                                        </v-btn>
                                                    </template>
                                                    <span> Elective Time Table </span>
                                                </v-tooltip>
                                            </span>
                                        </span>
                                        <v-btn v-if="data.toshowcompulsory == 2" text width="100%" small>
                                            <span v-if="data.tt_course != null">
                                                <v-icon small color="green">mdi-book-open-page-variant</v-icon>
                                                {{ data.tt_course }}
                                            </span>
                                            <span v-if="showRoom && data.tt_room != null">
                                                <v-icon color="blue" small>mdi-warehouse</v-icon>
                                                {{ data.tt_room }}
                                            </span>
                                            <span v-if="data.tt_event != null">
                                                <v-icon color="green" small>mdi-cricket</v-icon>
                                                {{ data.tt_event }}
                                            </span>
                                            <span v-if="data.tt_faculty != null">
                                                <v-icon color="#9808EB" small>mdi-account-tie</v-icon>
                                                {{ data.tt_faculty }}
                                            </span>
                                            <span v-if="data.tt_web_link != null && data.tt_web_link != '--'">
                                                <a :href="data.tt_web_link" v-if="data.tt_web_link" target="_blank">
                                                    <v-tooltip top>
                                                        <template v-slot:activator="{ on, attrs }">
                                                            <v-icon color="white" v-bind="attrs" v-on="on" size="25">mdi
                                                                mdi-link</v-icon>
                                                        </template>
                                                        <span> Webinar Link!!! </span>
                                                    </v-tooltip>
                                                </a>
                                            </span>
                                        </v-btn>
                                        <v-btn text v-if="data.toshowcompulsory == 3">
                                            <span v-if="data.tt_slot_type == 'Teaching'">

                                            </span>
                                            <span v-else>
                                                <v-btn small :color="data.tt_slot_color"> {{ data.tt_slot_type }}
                                                </v-btn>
                                            </span>
                                        </v-btn>
                                    </td>
                                </tr>
                            </tbody>
                        </v-simple-table>
                    </v-col>
                </div>
            </v-card>
        </v-card>
    </div>
</template>
<script>
import axios from "axios";
import "@/assets/css/color.css"; // css needs to be imported for each dashboard
export default {
    props: {
        uid: String,
        ay: String,
        stream: Array,
        org: Number,
        tt_version: Number,
        context: {
            type: String,
            default: "default"
        } 
    },
    data() {
        return {
            final_tt_list: null,
            day_list: null,
            slots: null,
            slot_type: null,
            faculty: null,
            tt_load: false,
            dis_ay: null,
            faculty_name: "",
            dialog: false,
            web_Link: null,
            tt_id: null,
            snackbar_msg: "",
            color: "",
            snackbar: false,
            org_basic_data: null,
            showRoom: true,
            selectedFacultyName: '',
        };
    },
    watch: {
        uid() {
            this.getData();
        },
        tt_version() {
            this.getData();
        }
    },
    mounted() {
        this.getData();
        this.getSelectedFaculty();
    },
    methods: {
        print() {
            this.$store.state.drawer = false;
            let that = this;
            window.onafterprint = function () {
                that.$store.state.drawer = true;
            };
            setTimeout(function () {
                window.print();
            }, 100);
        },
        fnExcelReport(id, name) {
            var tab_text = '<html xmlns:x="urn:schemas-microsoft-com:office:excel">';
            tab_text = tab_text + "<head><xml><x:ExcelWorkbook><x:ExcelWorksheets><x:ExcelWorksheet>";
            tab_text = tab_text + "<x:Name>Test Sheet</x:Name>";
            tab_text = tab_text + "<x:WorksheetOptions><x:Panes></x:Panes></x:WorksheetOptions></x:ExcelWorksheet>";
            tab_text = tab_text + "</x:ExcelWorksheets></x:ExcelWorkbook></xml></head><body>";
            tab_text = tab_text + "<table border='1px'>";
            var exportTable = $("#" + id).clone();
            exportTable.find("input").each(function (index, elem) {
                $(elem).remove();
            });
            exportTable.find('th, td').each(function () {
                $(this).css('border', '1px solid black');
            });
            tab_text = tab_text + exportTable.html();
            tab_text = tab_text + "</table></body></html>";
            var fileName = name + "_" + parseInt(Math.random() * 10000000000) + ".xls";
            const blob = new Blob([tab_text], { type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet" });
            const filename = name + ".xls";

            if (window.navigator && window.navigator.msSaveOrOpenBlob) {
                // For IE
                window.navigator.msSaveOrOpenBlob(blob, filename);
            } else {
                // For modern browsers
                const url = window.URL.createObjectURL(blob);
                const a = document.createElement("a");
                a.href = url;
                a.download = filename;
                a.click();
                window.URL.revokeObjectURL(url);
            }
        },
        showSnackbar(clr, msg) {
            this.snackbar = true;
            this.color = clr;
            this.snackbar_msg = msg;
        },
        getSelectedFaculty() {
            const storedFacultyName = localStorage.getItem('selectedFacultyName');
            if (storedFacultyName) {
                this.selectedFacultyName = storedFacultyName;
            } else {
                this.selectedFacultyName = 'No faculty selected.';
            }
        },
        getData() {
            this.tt_load = true;
            const formData = {
                uid: this.uid,
                ay: this.ay,
                stream: this.stream,
                org: this.org,
                tt_version: this.tt_version
            };
            const apiUrl =
            this.context === "individual"
                ? "/timeTable/facultyIndividualTimeTable3"
                : "/timeTable/facultyTimeTablev3";
            axios
                .post(apiUrl, formData)
                .then((res) => {
                    console.log(res.data);
                    if (res.data.flag == "YES") {
                        this.final_tt_list = res.data.final_tt_list;
                        this.day_list = res.data.day_list;
                        this.org_basic_data = res.data.org_basic_data
                        // this.faculty = res.data.faculty;
                        // this.dis_ay = res.data.ay;
                        // this.faculty_name = res.data.faculty_name;
                    } else {
                        alert(res.data.status_reason);
                    }
                })
                .catch((error) => {
                    alert("Somthing went wrong!!!");
                })
                .finally(() => {
                    //stop loader
                    this.tt_load = false;
                });
        },
    },
};
</script>
<style scoped>
a:link {
    text-decoration: none !important;
}

v-simple-table {
    white-space: nowrap !important;
    text-align: center;
}

.mytable /deep/ thead th {
    background: #0f2027 !important;
    /* fallback for old browsers */
    background: -webkit-linear-gradient(to right, #2c5364, #203a43, #0f2027) !important;
    /* Chrome 10-25, Safari 5.1-6 */
    background: linear-gradient(to right, #2c5364, #203a43, #0f2027) !important;
    /* W3C, IE 10+/ Edge, Firefox 16+, Chrome 26+, Opera 12+, Safari 7+ */
    background-color: #0f2027 !important;
    color: white !important;
    font-weight: bold !important;
    white-space: nowrap !important;
    text-align: center;
}

.mytable,
td {
    border: 1px solid black;
}

.checkbox-label {
    /* color: #fff !important; */
    margin-left: 10px;
    margin-top: 24px;
}

.btn-grad {
    /* background-image: linear-gradient(to right, #abbaab 0%, #ffffff  51%, #abbaab  100%) */
}

.btn-grad {
    text-align: center;
    text-transform: uppercase;
    transition: 0.5s;
    background-size: 200% auto;
    color: black;
    border-radius: 10px;
    display: block;
}

.btn-grad:hover {
    background-position: right center;
    /* change the direction of the change here */
    color: black;
    text-decoration: none;
}

.btn1-grad {
    background-image: linear-gradient(to right, #085078 0%, #85d8ce 51%, #085078 100%);
}

.btn1-grad {
    text-align: center;
    text-transform: uppercase;
    transition: 0.5s;
    background-size: 200% auto;
    color: white;
    box-shadow: 0 0 20px #eee;
    border-radius: 10px;
    display: block;
}

.btn1-grad:hover {
    background-position: right center;
    /* change the direction of the change here */
    color: #fff;
    text-decoration: none;
}

@media print {

    header,
    footer,
    nav,
    date {
        display: none !important;
    }

    table,
    td,
    tr {
        break-inside: avoid-page;
    }

    body,
    tr,
    th,
    td {
        font-size: 14pt !important;
        font-weight: bold !important;
    }

    .no-display,
    .v-input__control,
    input[type="button"],
    input[type="submit"],
    input[type="reset"],
    #v-card {
        display: none !important;
    }


    @page {
        size: A4;
        margin-top: none;
        padding-top: none;
        size: 16in 20in;
    }

}
</style>
